import React from 'react';
import type { DiagnosticValueHistory } from '@data/datahub/diagnostics/types';
import { TableCell, TableRow, Typography } from '@mui/material';
import { DateTime } from 'luxon';

type Props = {
  no: number;
  valueHistory: DiagnosticValueHistory;
};

const DiagnosticValueHistoryItem: React.FC<Props> = ({
  no,
  valueHistory,
}: Props) => (
  <TableRow>
    <TableCell data-testid={`No${no}-loadValue`}>{no}</TableCell>
    <TableCell data-testid={`No${no}-loadValue-startTime`}>
      {DateTime.fromISO(valueHistory.timestamp).toFormat(
        'yyyy/MM/dd HH:mm:ss.SSS',
      )}
    </TableCell>
    <TableCell data-testid={`No${no}-loadValue-value`}>
      {valueHistory.values.map((value, i) => (
        <Typography key={`value_${i}`} data-testid={value.key}>
          <strong>{value.key}</strong>: {value.value}
        </Typography>
      ))}
    </TableCell>
  </TableRow>
);

export default React.memo(DiagnosticValueHistoryItem);
